import {
    CLEAR_USER_DETAILS,
    CLEAR_USER_LIST,
    SET_USER_DETAILS,
    SET_USER_FILTER_DATA,
    SET_USER_LIST,
    USER_CREATE_DIALOG_CLOSE,
    USER_CREATE_DIALOG_OPEN,
    USER_CREATE_ERROR,
    USER_CREATE_ERROR_CLEAR,
    USER_CREATE_PENDING,
    USER_DETAILS_ERROR,
    USER_DETAILS_ERROR_CLEAR,
    USER_DETAILS_PENDING,
    USER_EDIT_DIALOG_CLOSE,
    USER_EDIT_DIALOG_OPEN,
    USER_EDIT_ERROR,
    USER_EDIT_ERROR_CLEAR,
    USER_EDIT_PENDING,
    USER_FILTER_DIALOG_CLOSE,
    USER_FILTER_DIALOG_OPEN,
    USER_LIST_ERROR,
    USER_LIST_ERROR_CLEAR,
    USER_LIST_PENDING,
    USER_PASSWORD_RESET_ERROR,
    USER_PASSWORD_RESET_ERROR_CLEAR,
    USER_PASSWORD_RESET_PENDING,
    USER_PASSWORD_RESET_SUCCESS
} from "./constants"

const initialState = {

    //-----------------------------|| LIST ||---------------------------------------------------------------
    userList: null,
    userListCount: 0,
    isUserListPending: false,
    userListErrorMessage: null,
    //-----------------------------|| FILTER ||-------------------------------------------------------------
    isUserFilterDialogOpen: false,
    userFilterData: null,
    //-----------------------------|| DETAILS ||------------------------------------------------------------
    userDetails: null,
    isUserDetailsPending: false,
    userDetailsErrorMessage: null,
    //-----------------------------|| RESET USER PASSWORD ||------------------------------------------------
    isResetUserPasswordPending: false,
    resetUserPasswordErrorMessage: null,
    //-----------------------------|| CREATE ||-------------------------------------------------------------
    isUserCreateDialogOpen: false,
    isUserCreatePending: false,
    userCreateErrorMessage: null,
    //-----------------------------|| EDIT ||---------------------------------------------------------------
    isUserEditDialogOpen: false,
    isUserEditPending: false,
    userEditErrorMessage: null,
}

const users = (state = initialState, action) => {

    switch (action.type) {
        //-----------------------------|| LIST ||---------------------------------------------------------------
        case USER_LIST_PENDING: {
            return {
                ...state,
                isUserListPending: true,
                userListErrorMessage: null,
            }
        }

        case SET_USER_LIST: {
            const { userList } = action.payload || {};
            return {
                ...state,
                userList: userList['value'],
                userListCount: userList['@odata.count'],
                isUserListPending: false,
                userListErrorMessage: null,
            }
        }

        case USER_LIST_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                userListErrorMessage: errorMessage,
                isUserListPending: false,
                userList: null,
                userListCount: 0,
            }
        }

        case USER_LIST_ERROR_CLEAR: {
            return {
                ...state,
                userListErrorMessage: null,
                isUserListPending: false,
            }
        }
        case CLEAR_USER_LIST: {
            return {
                ...state,
                userList: null,
                userListCount: 0,
            }
        }

        //-----------------------------|| FILTER ||-------------------------------------------------------------
        case USER_FILTER_DIALOG_OPEN: {
            return {
                ...state,
                isUserFilterDialogOpen: true,
            }
        }
        case USER_FILTER_DIALOG_CLOSE: {
            return {
                ...state,
                isUserFilterDialogOpen: false,
            }
        }

        case SET_USER_FILTER_DATA: {
            const { filter } = action.payload || {};
            return {
                ...state,
                userFilterData: filter,
            }
        }

        //-----------------------------|| DETAILS ||---------------------------------------------------------------
        case USER_DETAILS_PENDING: {
            return {
                ...state,
                isUserDetailsPending: true,
                userDetailsErrorMessage: null,
            }
        }

        case SET_USER_DETAILS: {
            const { userDetails } = action.payload || {};
            return {
                ...state,
                userDetails: userDetails,
                isUserDetailsPending: false,
                userDetailsErrorMessage: null,
            }
        }

        case USER_DETAILS_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                userDetailsErrorMessage: errorMessage,
                isUserDetailsPending: false,
                userDetails: null,
            }
        }

        case USER_DETAILS_ERROR_CLEAR: {
            return {
                ...state,
                userDetailsErrorMessage: null,
                isUserDetailsPending: false,
            }
        }
        case CLEAR_USER_DETAILS: {
            return {
                ...state,
                userDetails: null,
            }
        }

        //-----------------------------|| RESET USER PASSWORD ||---------------------------------------------------
        case USER_PASSWORD_RESET_PENDING: {
            return {
                ...state,
                isResetUserPasswordPending: true,
                resetUserPasswordErrorMessage: null,
            }
        }

        case USER_PASSWORD_RESET_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                resetUserPasswordErrorMessage: errorMessage,
                isResetUserPasswordPending: false,
            }
        }

        case USER_PASSWORD_RESET_ERROR_CLEAR: {
            return {
                ...state,
                resetUserPasswordErrorMessage: null,
                isResetUserPasswordPending: false,
            }
        }

        case USER_PASSWORD_RESET_SUCCESS: {
            return {
                ...state,
                resetUserPasswordErrorMessage: null,
                isResetUserPasswordPending: false,
            }
        }

        //-----------------------------|| CREATE ||---------------------------------------------------------------
        case USER_CREATE_DIALOG_OPEN: {
            return {
                ...state,
                isUserCreateDialogOpen: true,
            }
        }
        case USER_CREATE_DIALOG_CLOSE: {
            return {
                ...state,
                isUserCreateDialogOpen: false,
            }
        }

        case USER_CREATE_PENDING: {
            return {
                ...state,
                isUserCreatePending: true,
                userCreateErrorMessage: null,
            }
        }

        case USER_CREATE_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                userCreateErrorMessage: errorMessage,
                isUserCreatePending: false,
            }
        }

        case USER_CREATE_ERROR_CLEAR: {
            return {
                ...state,
                userCreateErrorMessage: null,
                isUserCreatePending: false,
            }
        }

        //-----------------------------|| EDIT ||---------------------------------------------------------------
        case USER_EDIT_DIALOG_OPEN: {
            return {
                ...state,
                isUserEditDialogOpen: true,
            }
        }
        case USER_EDIT_DIALOG_CLOSE: {
            return {
                ...state,
                isUserEditDialogOpen: false,
            }
        }

        case USER_EDIT_PENDING: {
            return {
                ...state,
                isUserEditPending: true,
                userEditErrorMessage: null,
            }
        }

        case USER_EDIT_ERROR: {
            const { errorMessage } = action.payload || {};
            return {
                ...state,
                userEditErrorMessage: errorMessage,
                isUserEditPending: false,
            }
        }

        case USER_EDIT_ERROR_CLEAR: {
            return {
                ...state,
                userEditErrorMessage: null,
                isUserEditPending: false,
            }
        }

        default: {
            return state;
        }
    }
}

export default users;